import React from 'react';
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import KeyboardArrowRightRoundedIcon from '@mui/icons-material/KeyboardArrowRightRounded';
import ListAltRoundedIcon from '@mui/icons-material/ListAltRounded';
import { DashboardSectionTitle } from '../dashboard/DashboardSectionTitle';
import { formatDisplayDate } from '../../utils/dashboardData';
import { formatKilos, formatPercent } from '../../utils/flujoCalculations';

export const EntradasTable = ({
  rows,
  warehouses = [],
  users = [],
  title,
  onRowClick,
}) => (
  <Paper
    elevation={0}
    sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 2, overflow: 'hidden' }}
  >
    {title && (
      <DashboardSectionTitle icon={<ListAltRoundedIcon />} sx={{ p: 2, pb: 1 }}>
        {title}
      </DashboardSectionTitle>
    )}
    <TableContainer sx={{ overflowX: 'auto' }}>
      <Table size="small" sx={{ minWidth: 1180 }}>
        <TableHead>
          <TableRow sx={{ bgcolor: '#fbfbfc' }}>
            <TableCell>Codigo</TableCell>
            <TableCell>Fecha</TableCell>
            <TableCell>Almacen</TableCell>
            <TableCell>Creado por</TableCell>
            <TableCell>Variedad</TableCell>
            <TableCell align="right">Kg volcados</TableCell>
            <TableCell align="right">Kg reales</TableCell>
            <TableCell align="right">Kg clasificados</TableCell>
            <TableCell align="right">Rendimiento</TableCell>
            {/* <TableCell align="right">Palots</TableCell> */}
            <TableCell align="right" />
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => {
            const warehouse = warehouses.find((item) => item.id === row.idAlmacen);
            const user = users.find((item) => item.id === row.idUsuarioCreador);

            return (
              <TableRow
                key={row.codigo}
                hover
                onClick={() => onRowClick?.(row)}
                sx={{
                  cursor: onRowClick ? 'pointer' : 'default',
                  '&:hover': onRowClick
                    ? {
                        bgcolor: '#fff8f2',
                      }
                    : undefined,
                }}
              >
                <TableCell sx={{ py:1.3}}>
                  <Typography sx={{ fontWeight: 900 }}>#{row.codigo}</Typography>
                </TableCell>
                <TableCell>{formatDisplayDate(row.fecha)}</TableCell>
                <TableCell>{warehouse?.nombre || 'Sin almacen'}</TableCell>
                <TableCell>{user?.nombre || 'Sin usuario'}</TableCell>
                <TableCell>{row.variedad}</TableCell>
                <TableCell align="right">{formatKilos(row.kilosVolcados)} kg</TableCell>
                <TableCell align="right">{formatKilos(row.kgReales)} kg</TableCell>
                <TableCell align="right">{formatKilos(row.kilosClasificados)} kg</TableCell>
                <TableCell align="right">{formatPercent(row.rendimiento)} %</TableCell>
                {/* <TableCell align="right">{formatKilos(row.totalPalots)}</TableCell> */}
                <TableCell align="right">
                  {onRowClick && (
                    <Box sx={{ color: 'text.secondary', display: 'inline-flex' }}>
                      <KeyboardArrowRightRoundedIcon fontSize="small" />
                    </Box>
                  )}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  </Paper>
);
